const getFormatedTitle = (title) => {
    return title.toLowerCase().replace(/\s/g, '-');
};

export const getTabpanelId = (tabId, title) => {
    const formattedTitle = getFormatedTitle(title);

    return tabId ? `${tabId}-tabpanel` : `${formattedTitle}-tabpanel`;
};

export const getFormatedTabId = (tabId, title) => {
    const formattedTitle = getFormatedTitle(title);

    return tabId ? tabId : `${formattedTitle}-tab`;
};
